// TODO: make staging env api url key as same as dashboard dev env
import mapValues from "lodash/fp/mapValues";

const SOCKETSURL = process.env.SOCKETS_URL || process.env.BUILD_SOCKETS_URL;
const baseUrl = SOCKETSURL;
const endpoints = {
  customer: "customer",
  dashboard: "dashboard",
};

const concatUrl = (url) => baseUrl + url;
const sockets = mapValues(concatUrl)(endpoints);

export default sockets;



// WEBPACK FOOTER //
// ./src/core/sockets.js